import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as __ from 'lodash';
import * as _ from 'underscore';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
declare const clevertap;

/**
 * Format of data used in recent history
 */
type HISTORY_DATA = {
  type: string,
  name: string,
  companylogo: string | null,
  companyid: string | null,
  updatedon:string | null
}

@Component({
    selector: 'app-new-compnay-page',
    templateUrl: './new-compnay-page.component.html',
    styleUrls: ['./new-compnay-page.component.scss'],
    standalone: false
})
export class NewCompnayPageComponent implements OnInit {

  fortunecompnies: any
  industrydata: any
  typeahead_search: UntypedFormControl = new UntypedFormControl(null)
  typeaheaddata: any;
  searcherror: boolean = false;
  industryCount:number=4
  private typeAheadSubject = new Subject<{ event: Event }>();

  /**All Search history modal */
  @ViewChild('historymodal') historymodal: TemplateRef<any>;

  /**Search History data */
  historyData: HISTORY_DATA[] = [];

  /** Recent search data */
  recentSearchData: HISTORY_DATA[] = [];

  /** Pagination of search histroy modal */
  searchHistoryPagination: number = 0;

  // conmpany typeahead subscription
  typeaheadSubscription: Subscription = null;

  constructor(private modalService: NgbModal, private companyinsightsservice: CompanyInsightsService, private router: Router, private personSearchService: PersonSearchService,
    private localStorgeService: LocalStorageService) { }

  ngOnInit(): void {
    this.getfortunecompanies();
    this.getaggregateIndustry()
    this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event }) => {
      this.getTypeaheads(event);
    });
    this.getHistory();
  }

  // Call this function whenever the user types something
  onTypeAheadSearch(event: Event) {
    // Emit the event and type as an object through the typeAheadSubject to apply debounce
    this.typeAheadSubject.next({ event });
  }

  /**
   * Search history modal
   */
  openHistoryModal() {
    this.modalService.open(this.historymodal, { windowClass: "small-modal", centered: true })
  }

  /**
   * Foramt date in ('Do MMM YY | hh:mm A') format
   * @param x date
   * @returns
   */
  formatDate(x) {
    return moment(x).format('Do MMM YY | hh:mm A')
  }

  getfortunecompanies() {
    let payload = {
      startindex: 0,
      resultsize: 4,
      searchviaboolean: true,
      booleanquery: "*",
      industries: [],
      locations: [],
      companysizes: [],
      companybuckettypes: ["Fortun500"]
    }
    this.companyinsightsservice.getRecommendedcompanies(payload).subscribe((res:any)=>{
      if(res.status == "success") {
        this.fortunecompnies = res.data.results.map(c => ({ ...c, tags: c.tags ? c.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) : [] }));
      }
    })
  }

  getaggregateIndustry(type?:any) {
   let payload =  {
      startindex: 1,
      resultsize: 4,
      searchviaboolean: true,
      booleanquery: "*",
      industries: [],
      locations: [],
      companysizes: [],
      aggregatetype: "industry",
      aggregatescount:this.industryCount + 4,
    }

  this.companyinsightsservice.getIndustryAggregates(payload).subscribe((res:any)=>{
    if(res.status == "success") {

      this.industrydata = this.chunkArray(res.data.aggregations.industries, 4)
      // this.industrydata = res.data.aggregations.industries
      this.getTopCompaniesForIndustry();
    }
  })

  }

  getTypeaheads(event) {
    this.searcherror = false
    const input = event.target.value
    this.typeaheadSubscription &&  this.typeaheadSubscription.unsubscribe();
    this.typeaheadSubscription = this.companyinsightsservice.getCompanyTypeaheads(input).subscribe((res:any)=>{
      // this.typeaheaddata = res.data
      const companyList = res.data;
      if(res?.data?.length){
        const companyLogoPayload = res?.data.map(item=>{
          if(item.id || item.value){
            return{
              ...(item?.id && {id: item.id}),
              ...(item?.value && {name: item.value})
            }
          }
        }).filter(Boolean);

        companyLogoPayload?.length &&
        this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((response: any) => {
          this.typeaheaddata = companyList.map(c => ({
            ...c, companylogo: response.data.filter(r => {
              if (r.searchedVia === 'id') {
                return r.key === c.id;
              } else if (r.searchedVia === 'name') {
                return r.key === c.value;
              }
            }
            )[0]?.companylogo
          }));
        });
      }
    })
  }

  redirecttoAllListing() {
    this.searcherror = false
    if(this.typeaheaddata?.length > 0) {
      const inputkeyword = this.typeaheaddata.filter(x=>x.value.toLowerCase() == this.typeahead_search.value.toLowerCase())
      if(inputkeyword.length > 0) {
        if(this.typeahead_search.value)
        this.router.navigate(['/company-list'], { queryParams: {keyword: this.typeahead_search.value } })
      } else {
        this.searcherror = true;
      }
    } else {
      this.router.navigate(['/company-list'])
    }

  }

  /**
   * Used to set history on search in company insights
   * @param data
   * @param selectionType e.g. company or industry
   */
  setCompanyInsightsHistory(data, selectionType: string) {
    const payload = {
      ...((selectionType === 'company') && {
        companies: [
          data.name
        ],
        companyids: [
          data.id
        ]
      }),
      ...((selectionType === 'industry') && {
        industries: [
          data.name
        ]
      }),
      module: GlobalService.HISTORY_MODULE.COMPANY_INSIGHTS
    }
    this.personSearchService.setInsightsHistory(payload).subscribe();
  }

  selectTypeahead(data) {
    this.typeahead_search.patchValue(data.value);
    if (data.id) {
      this.setCompanyInsightsHistory({name: data.value, id: data.id}, 'company');
          /**
           * Company Insights viewed
           */
        const companyInsightsParams = {
          "User ID": this.localStorgeService.getItem('userdata').userid,
          "Company name": data.value,
          "Source": "search",
          "Filters Applied": "none"

        }
        clevertap.event.push('Company Insights Viewed', companyInsightsParams);
      this.router.navigate([`/company-details/${data.id}`])
    } else {
      this.setCompanyInsightsHistory({name: data.value}, 'industry')
      this.redirecttoAllListing();
    }
  }

  redirecttoCompanydetails(industry) {
    this.router.navigate(['/company-list'], { queryParams: {industry: industry } })
  }

  redirectToCompanyDetailsPage(company) {
    /**
           * Company Insights viewed
           */
     const companyInsightsParams = {
      "User ID": this.localStorgeService.getItem('userdata').userid,
      "Company name": company.name,
      "Source": "search",
      "Filters Applied": "none"

    }
    clevertap.event.push("Company Insights Viewed",companyInsightsParams);
    this.router.navigate([`/company-details/${company.id}`])
  }

  /**
   * Get recent search history
   */
  getHistory(type = '') {
    if (type == 'scroll') {
      this.searchHistoryPagination += 10;
    }
    this.personSearchService.getSearchHistory(this.searchHistoryPagination, GlobalService.HISTORY_MODULE.COMPANY_INSIGHTS).subscribe((res) => {
      if (res.status == 'success' && Array.isArray(res.message) && res?.message?.length) {
        res.message.map(data => {
          const queryObj = JSON.parse(data.query);
          const obj = {
            type: (queryObj.companies) ? 'company' : 'industry',
            name: queryObj.companies || queryObj.industries,
            companylogo: null,
            companyid: queryObj.companyids,
            updatedon: data.updatedon,
          }
          if (obj.name) this.historyData.push(obj);
        })

        const companyLogoPayload = this.historyData.map(item => {
          if (item?.type === 'company' && (item.companyid || item.name)) {
            return {
              ...(item.companyid && { id: item.companyid }),
              ...(item.name && { name: item.name })
            }
          }
        }).filter(Boolean);

        const logoMapping = new Map();
        companyLogoPayload.length &&
          this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res) => {
            res?.data?.map((item: any) => {
              logoMapping.set(item.key, { logo: item.companylogo, companyid: item.id });
            })
            // this.historyData = this.historyData.slice(0,5);
            this.historyData.forEach(item => {
              if (item?.type == 'company') {
                if(item?.companyid){
                  item['companylogo'] = logoMapping.get(item.companyid)['logo'];
                } else if(item?.name){
                  item['companylogo'] = logoMapping.get(item.name)['logo'];
                }
                // item['companyid'] = logoMapping.get(item.name)['companyid'];
              }
            })
          })
        if(this.searchHistoryPagination === 0){
          this.recentSearchData = this.historyData;
          this.recentSearchData = _.uniq(this.recentSearchData, 'name');
        }
      }
    })
  }

  /**
   * Select recent history entery
   * @param data
   */
  selectRecentHistory(data) {
    this.modalService.dismissAll();
    this.searchHistoryPagination = 0;
    if (data.type === 'company') {
      this.setCompanyInsightsHistory({name: data.name, id: data.companyid}, 'company')
      this.router.navigate([`/company-details/${data.companyid}`]);
    } else if (data.type === 'industry') {
      this.setCompanyInsightsHistory({name: data.name}, 'industry')
      this.router.navigate(['/company-list'], { queryParams: { keyword: data.name } })
    }
  }

  redirecttocompany() {
    this.router.navigate(['/company-list'])
  }
  getIndustryIcon(industryName){
    let iconName = GlobalService.getIndustryIcon(industryName)
    return `text-webbtree-green fa-solid fa-${iconName}`
  }

  getTopCompaniesForIndustry(){
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
   let payload  = {"startindex":0,"resultsize":4,"searchviaboolean":true,
   "booleanquery":"*","industries":[],"locations":[],"companysizes":[], "islogorequired": true}
    // console.log(this.industrydata, 'this.industrydatathis.industrydatathis.industrydata')

    let clonedIndustryData = __.cloneDeep(this.industrydata.flat())
    let industries = clonedIndustryData.map(x => x.key)

    industries.forEach(ind => {
      payload.industries = [ind]

      this.companyinsightsservice.getRecommendedcompanies(payload).subscribe((res:any)=>{
        if(res.status == 'success'){
          const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
          //loadn[0].style.display = 'block'
          let results = res.data.results
          const logosByIndustry = {};
          // Populate the logosByIndustry object
          results.forEach(item => {
              if (industries.includes(item.industry)) {
                  if (!logosByIndustry[item.industry]) {
                      logosByIndustry[item.industry] = [];
                  }
                  if(logosByIndustry[item.industry] && logosByIndustry[item.industry].length < 4){
                    if(item && item.companylogo){
                      logosByIndustry[item.industry].push(item.companylogo);
                    }
                  }
              }
          });

          clonedIndustryData.forEach(item => {
              if (logosByIndustry.hasOwnProperty(item.key)) {
                  item.logos = logosByIndustry[item.key];
              }
          });

          this.industrydata = this.chunkArray(clonedIndustryData, 4)
        }
      })
    });
  }

  chunkArray(array: any[], size: number): any[] {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }
  removeTypeahead(type: any){
    const maxLength = 3
    switch (type) {
      case 'companyname': {
        if (!(this.typeahead_search && this.typeahead_search.value && this.typeahead_search.value.length >= maxLength)) {
          this.typeaheaddata = []
        }
        break;
      }
    }
  }

  ngOnDestroy() {
    this.searchHistoryPagination = 0;
    this.modalService.dismissAll()
  }
}

